import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { batch } from "@/core/modules/batch/objects/Batch";
import { BranchDpi } from "@/features/modules/branchDpi/objects/BranchDpi";
import { branchDpiModel } from "@/features/modules/branchDpi/models/BranchDpiModel";
import { DpiHandling } from "@/features/modules/dpiHandling/objects/DpiHandling";
import { DpiHandlingHelpers } from "@/features/modules/dpiHandling/helpers/DpiHandlingHelpers";
import { FirestoreModel } from "@/core/modules/firestore/models/FirestoreModel";

export const deliverDpisFromBranchToTrash = async (dpiHandling: DpiHandling): Promise<string> => {
  try {
    // check if dpis are available
    if (dpiHandling.sourceBranch === undefined) throw new Error("sourceBranch is undefined");
    const result: string = await DpiHandlingHelpers.checkDpisAvailabilityInBranch(dpiHandling, dpiHandling.sourceBranch.id);
    if (result !== "OK") return result;

    await FirestoreModel.runTransaction(async () => {
      if (dpiHandling.sourceBranch === undefined) throw new Error("sourceBranch is undefined");

      for (const handledDpi of dpiHandling.getHandledDpis()) {
        if (handledDpi.dpi === undefined) throw new Error("handledDpi dpi is undefined");
        if (handledDpi.size === undefined) throw new Error("handledDpi size is undefined");

        // check if branch dpi is available and if quantity is enough
        const branchDpi: BranchDpi | undefined = await branchDpiModel.getBranchDpiByDpiAndSize(
          handledDpi.dpi.id,
          handledDpi.size,
          dpiHandling.sourceBranch.id
        );
        if (branchDpi === undefined) throw new Error(`Dpi #${handledDpi.dpi.id} with size ${handledDpi.size} not available`);
        if (branchDpi.quantity < handledDpi.quantity) {
          throw new Error(
            `Dpi #${handledDpi.dpi.id} with size ${handledDpi.size} not available (requested quantity: ${handledDpi.quantity}, available quantity: ${branchDpi.quantity})`
          );
        }

        // update the branch dpi quantity or delete it if quantity is 0
        if (branchDpi.firestoreRef === undefined) throw new Error("branchDpi firestoreRef is undefined");
        if (branchDpi.quantity - handledDpi.quantity > 0) {
          batch.update(branchDpi.firestoreRef, { quantity: branchDpi.quantity - handledDpi.quantity });
        } else {
          batch.delete(branchDpi.firestoreRef);
        }
      }
      await batch.commit();
    });

    return "OK";
  } catch (error: unknown) {
    appFaultModel.catchAppError("DpiHandlingModel.deliverDpisFromBranchToTrash", { dpiHandling }, error);
    return "ERROR";
  }
};
